<template>
  <div class="row">
    <div class="col-12">
      <span class="left">Sélectionnez la lettre pour remplacer le joker : </span>
      <div class="select-letter">
        <div
        v-for="a in alpha"
        v-bind:key="a"
        class="flex-fill d-flex flex-column justify-content-center"
        v-on:click="selectLetter(a)">{{a}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelectLetter',
  emits: ['close-letter-selection'],
  data() {
    return {
      alpha: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
    };
  },
  methods: {
    selectLetter(letter) {
      this.$emit('close-letter-selection', letter);
    },
  },
};
</script>

<style>
.select-letter {
  width: 300px;
}
.select-letter div{
  font-size: 1.4em;
  background-color: #d9c28d;
  font-weight: bold;
  font-family: arial;
  height: 40px;
  width: 44px;
  position: relative;
  text-align: center;
  margin-left: 10px;
  margin-bottom: 10px;
  float: left;
  cursor: pointer;
}
</style>
